import React, { Fragment } from 'react'
import { requestFullScreen, exitFullScreen, isFullScreen } from 'aria-viewer/utils/fullScreen'
import compose from 'recompose/compose'
import pure from 'recompose/pure'
import withLifeCyle from 'recompose/lifecycle'
import withHandlers from 'recompose/withHandlers'

const lifecycle = withLifeCyle({
    componentDidMount: function() {
        let exitTimeout

        window.screen.orientation.onchange = function() {
            if (this.type.startsWith('landscape')) {
                clearTimeout(exitTimeout)
                requestFullScreen()
            } else {
                exitTimeout = setTimeout(() => {
                    exitFullScreen()
                }, 100)
            }
        }

        document.addEventListener('visibilitychange', this.props.onVisibilityChange)
    },

    componentWillUnMount: function() {
        window.screen.orientation.onchange = null
        document.removeEventListener('visibilitychange', this.props.onVisibilityChange)
    },
})

const handlers = withHandlers({
    onVisibilityChange: ({ isLandscape }) => event => {
        if (document.visibilityState == 'visible' && !isFullScreen() && isLandscape) requestFullScreen()
    },
})

const AndroidLandscapeFullscreen = ({ children }) => <Fragment>{children}</Fragment>

export default compose(
    handlers,
    lifecycle,
    pure
)(AndroidLandscapeFullscreen)
